import { useEffect, useState } from 'react';
export function useHomePageStore(storageKeyPrefix, midi) {
    const [selectedInputId, setSelectedInputId] = useState(() => {
        try {
            return localStorage.getItem(`${storageKeyPrefix}-midi-input`);
        }
        catch {
            return null;
        }
    });
    const [selectedOutputId, setSelectedOutputId] = useState(() => {
        try {
            return localStorage.getItem(`${storageKeyPrefix}-midi-output`);
        }
        catch {
            return null;
        }
    });
    useEffect(() => {
        if (midi.status === 'connected' && midi.selectedInputId && midi.selectedOutputId) {
            setSelectedInputId(midi.selectedInputId);
            setSelectedOutputId(midi.selectedOutputId);
        }
    }, [midi.status, midi.selectedInputId, midi.selectedOutputId]);
    return {
        isSupported: midi.isSupported,
        browserInfo: midi.browserInfo,
        sysExEnabled: midi.sysExEnabled,
        status: midi.status,
        error: midi.error,
        inputs: midi.inputs,
        outputs: midi.outputs,
        selectedInputId,
        selectedOutputId,
        deviceId: midi.deviceId,
        setSelectedInputId,
        setSelectedOutputId,
        setDeviceId: midi.setDeviceId,
        refresh: midi.refresh,
        reconnect: midi.reconnect,
        connect: async () => {
            if (selectedInputId && selectedOutputId) {
                await midi.connect(selectedInputId, selectedOutputId);
            }
        },
        disconnect: async () => {
            await midi.disconnect();
            setSelectedInputId(null);
            setSelectedOutputId(null);
        },
        probe: midi.probe
            ? async (options) => {
                const match = await midi.probe(options);
                if (match) {
                    setSelectedInputId(match.inputId);
                    setSelectedOutputId(match.outputId);
                }
                return match;
            }
            : undefined,
    };
}
//# sourceMappingURL=useHomePageStore.js.map